/* This is ment to build provide a quick starting point when starting new index type file */
import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import roundScreenStyle from './style';
import DscRoundScreen from './DscRounds';
import MobRoundScreen from './MobRounds';

export default function RoundScreen(props) {
	let style = roundScreenStyle();
	let isMobile = useContext(GlobalContext).isMobile;

	return isMobile ? <MobRoundScreen {...props} /> : <DscRoundScreen {...props} />;
}
